import { render, staticRenderFns } from "./BatchSelection.vue?vue&type=template&id=1a1ef396&scoped=true&"
import script from "./BatchSelection.vue?vue&type=script&lang=js&"
export * from "./BatchSelection.vue?vue&type=script&lang=js&"
import style0 from "./BatchSelection.vue?vue&type=style&index=0&id=1a1ef396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ef396",
  null
  
)

export default component.exports